import _ from 'lodash'

import {
  CLEAR_DEFECT_ERRORS_SUCCESS,
  CLEAR_DEFECT_SUCCESS,
  CREATE_DEFECT_FAILURE,
  CREATE_DEFECT_SUCCESS,
  LIST_DEFECTS_FAILURE,
  LIST_DEFECTS_SUCCESS,
  READ_DEFECT_FAILURE,
  READ_DEFECT_SUCCESS,
  SET_DEFECT_CURRENT_FIELD_SUCCESS,
  SET_DEFECT_ERRORS_SUCCESS,
  UPDATE_DEFECT_FAILURE,
  UPDATE_DEFECT_SUCCESS,
} from '../actions/defect'

const defect = (state = {}, action) => {
  switch (action.type) {
    case CREATE_DEFECT_SUCCESS:
    case UPDATE_DEFECT_SUCCESS:
      return state
    case READ_DEFECT_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case LIST_DEFECTS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CLEAR_DEFECT_SUCCESS:
      return _.omit(state, 'current')
    case SET_DEFECT_ERRORS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CLEAR_DEFECT_ERRORS_SUCCESS:
      return _.omit(state, 'errors')
    case SET_DEFECT_CURRENT_FIELD_SUCCESS:
      const current = state.current ? { ...state.current } : {}
      current[action.data.field] = action.data.value
      return {
        ...state,
        current
      }
    case CREATE_DEFECT_FAILURE:
    case UPDATE_DEFECT_FAILURE:
    case READ_DEFECT_FAILURE:
    case LIST_DEFECTS_FAILURE:
    default:
      return state
  }
}

export default defect


// WEBPACK FOOTER //
// ./src/reducers/defect.js